<!--
  荐购规则弹窗
  仅在用户登录机构为「江西财经大学图书馆」时显示
  Props:
    visible: Boolean，控制显隐（.sync）
-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="520px"
    custom-class="jiangou-rule-dialog"
    top="18vh"
    @update:visible="onUpdateVisible"
  >
    <!-- 红色头部 -->
    <div class="jiangou-header" slot="title">
      <div class="jiangou-title">荐购规则</div>
      <div class="jiangou-subtitle">江西财经大学图书馆 · 你选书我买单</div>
    </div>

    <!-- 主体内容 -->
    <div class="jiangou-body">
      <p class="jiangou-greet">亲爱的读者朋友们：</p>
      <p class="jiangou-intro">
        为了丰富馆藏资源，满足师生的个性化阅读需求，我馆特别推出"你选书我买单"活动！欢迎广大师生/读者积极参与，挑选您心仪的好书。
      </p>

      <!-- 机构通知（如「重要通知」，接口 /notice/get 返回） -->
      <div class="jiangou-notice" v-if="showNotice">
        <span class="jiangou-notice-tag">{{ noticeTitle }}</span>
        <div class="jiangou-notice-content">{{ noticeBody }}</div>
      </div>

      <div class="jiangou-rule">
        <span class="jiangou-label">荐购对象：</span>
        <span class="jiangou-text">全体在校师生/注册读者。</span>
      </div>
      <div class="jiangou-rule">
        <span class="jiangou-label">荐购范围：</span>
        <span class="jiangou-text">国内正式出版的图书（具体以我馆馆藏采选政策为准）。</span>
      </div>
      <div class="jiangou-rule">
        <span class="jiangou-label">荐购数量：</span>
        <span class="jiangou-text">每人推荐图书不超过10册，单本码洋不超过200元。同种图书总复本数不超过三本。</span>
      </div>
      <div class="jiangou-rule">
        <span class="jiangou-label">处理周期：</span>
        <span class="jiangou-text">图书馆将在收到荐购订单后10个工作日内加工上架。</span>
      </div>
      <div class="jiangou-rule">
        <span class="jiangou-label">到馆借阅：</span>
        <span class="jiangou-text">读者可在蛟桥园图书馆一楼"你选书我买单"专架借阅。</span>
      </div>

      <div class="jiangou-contact">
        咨询电话：资源建设部&nbsp;&nbsp;周老师&nbsp;&nbsp;83801303
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="jiangou-footer">
      <div class="jiangou-confirm-btn" @click="handleConfirm">我知道了</div>
    </div>
  </el-dialog>
</template>

<script>
import { getNotice } from '@/api/img'

export default {
  name: 'JiangouRuleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      noticeTitle: '',
      noticeBody: ''
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    // 仅当通知正文存在时才展示通知区块
    showNotice() {
      return !!this.noticeBody
    }
  },
  watch: {
    // 弹窗每次打开时（含首页刷新重新弹出）拉取最新通知
    dialogVisible(val) {
      if (val) this.fetchNotice()
    }
  },
  methods: {
    onUpdateVisible(val) {
      this.$emit('update:visible', val)
    },
    handleConfirm() {
      // 关闭当前弹窗；下次进入首页（含刷新）仍会再次弹出
      this.$emit('update:visible', false)
      this.$emit('confirm')
    },
    async fetchNotice() {
      try {
        const res = await getNotice({})
        if (res && res.code == 200 && res.data) {
          this.applyNotice(res.data)
        }
      } catch (e) {
        console.error('获取通知失败', e)
      }
    },
    applyNotice(data) {
      // data.content 为 JSON 字符串：{ noticeTitle, notices }；解析失败时回退为纯文本
      let title = data.title || '通知'
      let body = ''
      if (data.content) {
        try {
          const parsed = JSON.parse(data.content)
          title = parsed.noticeTitle || title
          body = parsed.notices || ''
        } catch (e) {
          body = data.content
        }
      }
      if (body) {
        this.noticeTitle = title
        this.noticeBody = body
      }
    }
  }
}
</script>

<style lang="scss">
/* 弹窗主体：去掉默认圆角阴影，让自定义红色头部无缝衔接 */
.jiangou-rule-dialog {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18) !important;

  .el-dialog__header {
    padding: 0;
    background: #ca1a1b;
  }
  .el-dialog__body {
    padding: 22px 28px 26px;
    background: #ffffff;
  }
  .el-dialog__footer {
    padding: 0;
    background: #ffffff;
    border-top: 1px solid #f0f0f0;
  }
}

/* 红色头部 */
.jiangou-header {
  padding: 26px 28px 22px;
  color: #ffffff;

  .jiangou-title {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 2px;
  }
  .jiangou-subtitle {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    opacity: 0.92;
  }
}

/* 主体内容 */
.jiangou-body {
  color: #333;
  font-size: 15px;
  line-height: 1.75;

  .jiangou-greet {
    margin: 0 0 6px;
    font-weight: 600;
  }
  .jiangou-intro {
    margin: 0 0 14px;
    text-indent: 2em;
  }

  .jiangou-rule {
    display: flex;
    align-items: flex-start;
    margin: 8px 0;

    .jiangou-label {
      flex-shrink: 0;
      color: #ca1a1b;
      font-weight: 600;
      margin-right: 4px;
    }
    .jiangou-text {
      flex: 1;
      color: #333;
    }
  }

  .jiangou-contact {
    margin-top: 16px;
    padding: 10px 14px;
    background: #fbeaea;
    color: #ca1a1b;
    font-size: 14px;
    text-align: center;
    border-radius: 4px;
  }

  /* 机构通知区块 */
  .jiangou-notice {
    margin: 14px 0;
    padding: 12px 16px;
    background: #fff7f7;
    border: 1px solid #f3c9c9;
    border-left: 4px solid #ca1a1b;
    border-radius: 6px;

    .jiangou-notice-tag {
      display: inline-block;
      margin-bottom: 8px;
      padding: 2px 10px;
      background: #ca1a1b;
      color: #ffffff;
      font-size: 13px;
      font-weight: 600;
      border-radius: 3px;
    }
    .jiangou-notice-content {
      color: #444;
      font-size: 14px;
      line-height: 1.7;
      white-space: pre-wrap;
    }
  }
}

/* 底部红色按钮 */
.jiangou-footer {
  padding: 0;
  background: #ca1a1b;

  .jiangou-confirm-btn {
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
    transition: background 0.2s;

    &:hover {
      background: #b01516;
    }
    &:active {
      background: #9c1213;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Components/JiangouRuleDialog.vue